import { ViewModel,View, ObservableArray, Component } from "binder"
import { MultiSelectComboBoxView } from "../multiSelectComboBox1/multiSelectComboBox-view";

export class MultiSelectComboBoxViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    
        this.items = ObservableArray.create<ViewModel>();
        this.selecteditems = ObservableArray.create<ViewModel>();
    }
    GetDefaultView(): View <ViewModel> {
        return new MultiSelectComboBoxView();
    }
    public getTypeId(): string {
        return "VM-A2D663A4-B4C8-4F3A-86EF-E24588B969E3"
    }

    
    public set items(v: ObservableArray<ViewModel>) { this._items = v; } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    public set selecteditems(v: ObservableArray<ViewModel>) { this._selecteditems = v; } public get selecteditems(): ObservableArray<ViewModel> { return this._selecteditems;} private _selecteditems: ObservableArray<ViewModel>;
    public set searchpath(v: string) { this._searchpath = v; } public get searchpath(): string { return this._searchpath;} private _searchpath: string;
    
}
